import { useState } from "react";
import { Trash2 } from "lucide-react";
import { GridHeader } from "@/components/viewer/GridHeader";

const NumCell = ({ r, n, dup, onRemove }) => (
  <td className={`border-r border-slate-100 px-1 py-2 text-center font-mono text-[11px] ${dup ? "bg-amber-100 text-amber-800" : "bg-slate-50 text-slate-400"}`}>
    {n}
    {dup && (
      <button type="button" data-testid={`remove-row-${r.idx}`} onClick={() => onRemove(r.idx)} title="Rimuovi questa riga"
        className="mx-auto mt-1 flex h-6 w-6 items-center justify-center rounded-md text-amber-700 hover:bg-amber-200 hover:text-red-700">
        <Trash2 className="h-3.5 w-3.5" />
      </button>
    )}
  </td>
);

const Row = ({ r, n, dup, onRemove }) => (
  <tr data-testid={`grid-row-${r.idx}`} data-duplicate={dup ? "true" : undefined}
    className={`group border-b border-slate-100 ${dup ? "bg-amber-50/70 hover:bg-amber-50" : "hover:bg-emerald-50/60"}`}>
    <NumCell r={r} n={n} dup={dup} onRemove={onRemove} />
    <td className="border-r border-slate-100 px-3 py-2 font-mono text-xs text-slate-700 whitespace-nowrap">{r.data_operazione}</td>
    <td className="border-r border-slate-100 px-3 py-2 font-mono text-xs text-slate-700 whitespace-nowrap">{r.data_valuta}</td>
    <td className="border-r border-slate-100 px-3 py-2 text-xs text-slate-700 leading-relaxed">
      {dup && <span data-testid={`dup-badge-${r.idx}`} className="mr-2 rounded bg-amber-200 px-1.5 py-0.5 text-[10px] font-semibold uppercase text-amber-900">Copia {dup.pos + 1}/{dup.size}</span>}
      {r.descrizione}
    </td>
    <td className="border-r border-slate-100 px-3 py-2 text-right font-mono text-xs text-red-600 whitespace-nowrap">{r.addebiti}</td>
    <td className="px-3 py-2 text-right font-mono text-xs text-emerald-700 whitespace-nowrap">{r.accrediti}</td>
  </tr>
);

const PAGE = 300;

export const DataGrid = ({ rows, dupInfo, onRemove, ...headerProps }) => {
  const [limit, setLimit] = useState(PAGE);
  const shown = rows.slice(0, limit);
  return (
    <div data-testid="data-grid" className="max-h-[68vh] overflow-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-[960px] border-collapse text-left">
        <GridHeader {...headerProps} />
        <tbody>
          {shown.map((r, i) => <Row key={r.idx} r={r} n={i + 1} dup={dupInfo.get(r.idx)} onRemove={onRemove} />)}
          {rows.length > limit && (
            <tr>
              <td colSpan={6} className="px-4 py-4 text-center text-sm text-slate-500">
                Visualizzate {limit} di {rows.length} righe (il download le include tutte).
                <button type="button" data-testid="grid-show-more" onClick={() => setLimit((l) => l + PAGE * 5)}
                  className="ml-3 font-semibold text-emerald-700 underline underline-offset-4">Mostra altre</button>
              </td>
            </tr>
          )}
        {!rows.length && (
          <tr>
            <td colSpan={6} data-testid="grid-empty" className="px-4 py-16 text-center text-sm text-slate-500">
              Nessuna riga corrisponde ai filtri.
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );
};
